export const getFileType = (fileName = '') => {
  const ext = fileName.split('.').pop()?.toLowerCase();

  const videoTypes = ['mp4', 'webm', 'ogg', 'mov', 'avi', 'mkv', 'flv', 'wmv', '3gp', 'm4v', 'mpeg', 'mpg'];
  const audioTypes = ['mp3', 'wav', 'aac', 'ogg', 'oga', 'm4a', 'flac', 'wma', 'amr', 'aiff', 'opus'];

  if (videoTypes.includes(ext)) return 'video';
  if (audioTypes.includes(ext)) return 'audio';
  if (ext === 'pdf') return 'pdf';

  return 'image';
};
